export default __webpack_public_path__ + "static/media/NR.7811dd2a.svg";